import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import EditorialMarquee from "@/components/site/Marquee";
import GlobalReach from "@/components/site/GlobalReach";
import Partners from "@/components/site/Partners";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function MarketingPage() {
  return (
    <SmoothScroll>
      <div className="relative bg-navy-base text-white grain min-h-screen" data-testid="marketing-page">
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Stats />
          <Services />
          <EditorialMarquee />
          <GlobalReach />
          <Partners />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
